import { Component, OnInit, Inject, HostListener, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
//import { Component, OnInit, ViewChild, ViewEncapsulation, Output, EventEmitter } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PropertiesService } from '../../Services/Properties/properties.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
// import { ImportOpsDashboardComponent } from 'src/app/dashboard/import-ops-dashboard/import-ops-dashboard.component';

declare var $: any;
// export interface DialogData {
//   rptId: string;
//   rptSPName: string;
// }
export interface DialogData {
  id: string;
  componentName: string;
  segment: string;
  JobSegment: string;
}
@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnInit {
  @ViewChild('container', { read: ViewContainerRef, static: true  }) viewContainerRef: ViewContainerRef;
  constructor(public dialogRef: MatDialogRef<PopupComponent>,
    private property: PropertiesService,
    private componentFactoryResolver: ComponentFactoryResolver,
    public sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA)
    public data: DialogData,
  ) { }
  uri = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);
  htmlStr: string = '';
  ngOnInit() {
    this.addEditor();
  }

  addEditor() {
  
  }
  closepopup() {
    this.dialogRef.close();
  }
  closeWindoe(){
    $("#closePpup").trigger("click");
    try{
    //   const factory = this.componentFactoryResolver.resolveComponentFactory(ImportOpsDashboardComponent);
    //   const ref = this.viewContainerRef.createComponent(factory);
    //   ref.instance.ReloadData();
    // //  ref.instance.setTick(this.data.segment);
    //   ref.changeDetectorRef.detectChanges();
      $("#closePpup").trigger("click");
    }catch{
      $("#closePpup").trigger("click");
    }
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
   this.closeWindoe();
  }
}
